import { Box, Tooltip } from "@mui/material";

import { PlacementFilterTooltipContent } from "./TooltipContent";

interface PlacementFilterTooltipProps {
  hasSeenPlacementFilterTooltip: boolean;
  setHasSeenPlacementFilterTooltip: () => void;
  children: React.ReactNode;
}

export function PlacementFilterTooltip(props: PlacementFilterTooltipProps) {
  const { hasSeenPlacementFilterTooltip, setHasSeenPlacementFilterTooltip, children } = props;
  return (
    <Tooltip
      arrow
      open={!hasSeenPlacementFilterTooltip}
      placement="bottom-end"
      slotProps={{
        popper: {
          disablePortal: true,
        },
        tooltip: {
          sx: {
            backgroundColor: (theme) => theme.palette.primary.main,
            borderRadius: 4,
            padding: 4,
          },
        },
        arrow: {
          sx: {
            color: (theme) => theme.palette.primary.main,
          },
        },
      }}
      title={<PlacementFilterTooltipContent onClose={setHasSeenPlacementFilterTooltip} />}
    >
      <Box component="span">{children}</Box>
    </Tooltip>
  );
}
